import React, {Component} from 'react';
import SearchBar from '../components/searchBar';
import NewSearchBar from '../components/NewSearchBar';

export class Layout extends Component {
  render() {
    return (
      <div className="main">
        {this.props.lvvEnabled ? (
          <NewSearchBar onSearch={this.props.onSearch} />
        ) : (
          <SearchBar onSearch={this.props.onSearch} />
        )}
        {this.props.children}
      </div>
    );
  }
}
